import CheckboxGroup from './src/checkbox-group'

export default CheckboxGroup